// Product item 

const colorSwatchItem = document.querySelectorAll('.grid-product .color-swatch');
if (colorSwatchItem) {
  colorSwatchItem.forEach(function (color) {
    color.addEventListener('click', function () {
      let image = this.getAttribute('data-variant-image');
      color.closest('.grid-product').querySelector('.grid__image-ratio img')?.setAttribute('srcset', image);
      let url = this.getAttribute('data-href');
      color.closest('.grid-product').querySelector('.grid-product__link')?.setAttribute('href', url);
      const target = color.getAttribute('data-color');
      color.closest('.grid-product__colors').querySelector('.sizes-for-color--is-visible').classList.remove('sizes-for-color--is-visible');
      color.closest('.grid-product__colors').querySelector(`#variant-${target}`).classList.add('sizes-for-color--is-visible');
    });
  });
}
window.addEventListener('DOMContentLoaded', () => {
  avoidReflow(document.querySelector('#slideshow-details-container'));
});
function avoidReflow(el) {
  if (!el?.id) return;
  var firstChild = el.firstChild;
  while (firstChild != null && firstChild.nodeType == 3) {
    // skip TextNodes
    firstChild = firstChild.nextSibling;
  }
  var style = document.createElement('style');
  style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
  document.head.appendChild(style);
}

// Header 

window.addEventListener('scroll', () => {
  if (window.matchMedia("(min-width: 768px)").matches && window.scrollY > 100 && document.querySelector('div[class*="rectangle-teaser"]')) {
    document.querySelector('div[class*="rectangle-teaser"]').style.marginTop = "-8px";
  } else if (window.matchMedia("(min-width: 768px)").matches && window.scrollY < 100 && document.querySelector('div[class*="rectangle-teaser"]')) {
    document.querySelector('div[class*="rectangle-teaser"]').style.marginTop = "revert-layer";
  } else if (window.matchMedia("(max-width: 425px)").matches && window.scrollY > 100 && document.querySelector('.template-collection div[class*="rectangle-teaser"]') || document.querySelector('.template-search div[class*="rectangle-teaser"]') || window.matchMedia("(max-width: 425px)").matches && window.scrollY < 100 && document.querySelector('div[class*="rectangle-teaser"]')) {
    document.querySelector('div[class*="rectangle-teaser"]').style.marginTop = "128px";
  } else if (window.matchMedia("(max-width: 425px)").matches && window.scrollY > 100 && document.querySelector('div[class*="rectangle-teaser"]')) {
    document.querySelector('div[class*="rectangle-teaser"]').style.marginTop = "68px";
  }
});